import { render, staticRenderFns } from "./garlic_product_man.vue?vue&type=template&id=80c86bcc&"
import script from "./garlic_product_man.vue?vue&type=script&lang=js&"
export * from "./garlic_product_man.vue?vue&type=script&lang=js&"
import style0 from "./garlic_product_man.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports